/**
 * Modulo de Firebase
 */

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import * as firebaseui from "firebaseui";

const firebaseConfig = {
  apiKey: "AIzaSyA42mJ5aKLQI-8kFt24thcEVIoInKkEQDk",
  authDomain: "fontumibots.firebaseapp.com",
  databaseURL: "https://fontumibots.firebaseio.com",
  projectId: "fontumibots",
  storageBucket: "fontumibots.appspot.com",
  messagingSenderId: "1047975832929",
  appId: "1:1047975832929:web:729ae2acf54d0200"
};

export const app = firebase.initializeApp(firebaseConfig);
// app.auth().useDeviceLanguage();
app.auth().languageCode = "es-Co";

let ui =
  firebaseui.auth.AuthUI.getInstance() ||
  new firebaseui.auth.AuthUI(app.auth());

/**
 * Inicializar Firebase UI
 * @param {HTMLElement} el Elemento donde se generaran los controles y botones
 */
export const initUI = async el => {
  await app.auth().setPersistence("local");

  ui.start(el, {
    signInFlow: "popup",
    signInOptions: [
      {
        provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID
      },
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
      {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        defaultCountry: "CO"
      }
    ],

    callbacks: {
      signInSuccessWithAuthResult: authResult => false,
      uiShown: () => {
        if (document.querySelector("ul.firebaseui-idp-list")) {
          document.querySelector(
            "ul.firebaseui-idp-list"
          ).style.paddingLeft = 0;
        }
      }
    },

    credentialHelper: firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM
  });
};

export const onAuthStateChanged = fn =>
  app.auth().onAuthStateChanged(user => fn(user));

export const firestore = async () => {
  await import("firebase/firestore");

  return app.firestore();
};
